
import { CommonButton } from '../../components/buttons';
import { Field, reduxForm } from 'redux-form';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderTextField } from '../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import { saveClearingHouseData, getClearingHouseDetails, getMasterData } from './actions/ClearingHouseActions';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import SmallLoader from '../../img/small-loader.gif';
import { displayCustomError } from '../../actions/utilAction';

export const stylesCss = {
  checkbox: {
    marginBottom: 16,
  },
};

class ClearingHouseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearingHouseId: props.clearingHouseId,
      open: true,
      masterEDIGateway : props.master_data ? props.master_data.masterEDIGateway : [],
      selectedValueClearingHouse : null,
    };
    this.handleChangeClearingHouseName = this.handleChangeClearingHouseName.bind(this);
  }

  componentWillMount() {
    if (this.state.clearingHouseId) {
      this.props.getClearingHouseDetails(this.state.clearingHouseId);
    }
    let masterData = {'masterdata' : 'MASTEREDIGATEWAY'}
    this.props.getMasterData(masterData)
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.master_data && this.props.master_data !== nextProps.master_data){
      let masterData = nextProps.master_data;
      this.setState({
        masterEDIGateway : masterData.masterEDIGateway,
      });
    }

    // on ESC key press close Dailog ...
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
  };

  handleChangeClearingHouseName = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    this.setState({selectedValueClearingHouse : selectedRecord.value})
  }

  handleSave=(formProps) => {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    let clearingHouseDetailId = this.props.clearingHouseDetails && this.props.clearingHouseDetails.data.masterEDIGatewayID;
    const selectedClearingHouse = (this.props.master_data && this.props.master_data.masterEDIGateway).find((item) =>{
      if(this.state.selectedValueClearingHouse){
        return item.id === this.state.selectedValueClearingHouse
      }else {
        return item.id === clearingHouseDetailId 
      }
    });
    formProps.id = this.state.clearingHouseId;
    formProps.MasterEDIGatewayID = this.state.selectedValueClearingHouse || clearingHouseDetailId;

    let clearingHouseName = selectedClearingHouse.clearingHouseName
    let obj = {
      ...formProps,
      clearingHouseName,
    }
    this.props.clearFieldErrorArray();
    this.props.saveClearingHouseData(obj);
    this.setState({ open: false });
    this.props.closeDialog();
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': 'CLEARINGHOUSE_CLEARINGHOUSENAME',
        'value': value,
        'colmnName': input.target.name,
        'id': this.state.selectedValueClearingHouse || 0,
        'patientId': 0,
        'additionalColmnId': '0'
      };
      this.props.checkFieldExistence(postData);
    }
  };

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <CommonButton label="Saving" className="loader_btn" primary={true} disabled = {true}/> : <CommonButton label="Save" type="submit" primary={true} onTouchTap={handleSubmit(this.handleSave.bind(this))} />;
    const actions = [
      <CommonButton
        className= 'mr-15 grey_btn' label="Cancel" onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={(this.state.clearingHouseId) ? 'Edit Clearing House' : 'Add Clearing House'}
          modal={false}
          actions={actions}
          open={this.state.open}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" noValidate >
                <div className="row">
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="MasterEDIGatewayID"
                      label="Select Clearing House Name"
                      options={this.state.masterEDIGateway}
                      disabled = {this.state.clearingHouseId? true : false}
                      handleNewRequest={this.handleChangeClearingHouseName}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 require">
                    <Field
                      name="ftpUsername"
                      label="FTP UserName"
                      onChange={(input, value) => this.checkFieldDataExistence(input, value, 'ftpusername')}
                      customError={displayCustomError('FTPUSERNAME', this.props.fieldError)} 
                      autoComplete='new-email'
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-4 require">
                    <Field
                      name="ftpPassword"
                      type ="password"
                      maxLength="30"
                      autoComplete='new-password'
                      label="FTP Password"
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-4 require">
                    <Field
                      name="ftpConfirmPassword"
                      type ="password"
                      autoComplete='new-password'
                      maxLength="30"
                      label="Confirm Password"
                      component={renderTextField}/>
                  </div>
                  <div className="col-sm-6 mt-35">
                    <Field
                      name="isPrimary"
                      label="Submit all claims to this clearing house"
                      component={renderCheckBox}
                    />
                </div> 
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let initialValuesData = null;
  if (ownProps.clearingHouseId && state.clearing_house.clearingHouseDetails) {
    let {masterEDIGatewayID , ...clearinghouseData} = state.clearing_house.clearingHouseDetails.data;
    initialValuesData = {
      ftpConfirmPassword: clearinghouseData.ftpPassword, 
      MasterEDIGatewayID: masterEDIGatewayID,
      ...clearinghouseData,
    };
  }
  return {
    loading: state.clearing_house.loading,
    master_data : state.clearing_house.master_data,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValuesData,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    clearingHouseDetails :state.clearing_house.clearingHouseDetails
  };
}

ClearingHouseModal = reduxForm({
  form: 'ClearingHouseModalForm',
  validate,
  enableReinitialize: true,
})(ClearingHouseModal);

export default connect(mapStateToProps, {getMasterData, checkFieldExistence, clearFieldErrorArray, saveClearingHouseData, getClearingHouseDetails })(ClearingHouseModal);



// WEBPACK FOOTER //
// ./src/modules/clearing-house/clearing-house-modal.js